// Shared tabs configuration for AI components
export const aiTabs = [
    {
        link: '/ai/agents',
        name: 'Agents'
    },
    {
        link: '/ai/tasks',
        name: 'Tasks'
    },
    {
        link: '/ai/tools',
        name: 'Tools'
    },
    {
        link: '/ai/llm-models',
        name: 'LLM Models'
    },
    {
        link: '/ai/speech-styles',
        name: 'Speech Styles'
    },
    {
        link: '/ai/transcripts',
        name: 'Transcripts'
    },
    {
        link: '/ai/call_logs',
        name: 'Call Logs'
    }
]; 